/**
 * This module wraps global environment variables declared when compiling.
 * See webpack.config.js for setting environment variables.
 */

export * from 'core/env'

declare const FEATURES: {
  GENERATE_SUBJECT_IDENTIFIERS: boolean,
}
export const ENV_FEATURES = FEATURES



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/env.ts